import classes from "./SearchOptions.module.css";
import {SearchOptions as Options } from "../../HomePage/inputSearch/SearchOptions";

const SearchOptions = () => {

  return (
    <div className={classes.container}>
        <Options />
    </div>
  );
};

export default SearchOptions;